const commonJa = {
  ja: {
    common: {
      logout: 'ログアウト',
      change_password_button: 'パスワード変更',
      my_plan: '保有プラン状況',
      my_profile: 'お客様登録情報',
      message_box: 'メッセージボックス',
      faq: 'よくある質問',
      contact_us: 'お問い合わせ',
      today: '今日',
      reset: 'リセット',
      submit: '続行',
      search: '検索',
      stage: '完成段階',
      status: '現状',
      type: 'タイプ',
      consultant: 'パートナー',
      search_rec_date: 'お申込書類受領日 (YYYY/MM/DD)',
      search_create_date: '作成日 (YYYY/MM/DD)',
      search_complete_date: '完了日 (YYYY/MM/DD)',
      included_team: 'サブパートナーを含む',
      documents: {
        no_file_found: 'No file found',
      },
      loading: '処理中...',
      sortable_column: 'ソート可能な列',
      please_select: '選択肢',
      close: '閉じる',
      pdf_version: 'PDF版',
      zip_version: 'ZIP',
      expand_tree: '拡大',
      collapse_tree: '縮小',
      main_site_contact_us: 'お問い合わせ',
      main_site_privacy: 'プライバシーポリシー',
      main_site_disclaimer: '免責条項',
      react_select_placeholder: '選択肢',
      per_page: '件表示',
      paginate_status: '{{size}} 件中 {{from}} - {{to}} まで表示',
      cannot_be_blank: '入力してください',
    },
    selection: {
      included_team: [['true', 'はい'], ['false', 'いいえ']],
      stage_type: [['nb', 'お手続中'], ['all', '全て'], ['select', '検索']],
      stage_options: [
        ['', ' - 全て -'],
        [1, 'ステージ 1'],
        [2, 'ステージ 2'],
        [3, 'ステージ 3'],
        [4, 'ステージ 4'],
        [5, 'ステージ 5'],
        [6, 'ステージ 6'],
        [7, 'ステージ 7'],
        [8, 'その他'],
      ],
      followup_type_options: [
        ['', ' - 全て -'],
        [6, '積立金未払いが発生しています'],
        [7, '契約更新'],
      ],
      type_options: [
        ['', ' - 全て - '],
        ['D', 'Discretionary'],
        ['N', 'Non-Discretionary'],
        ['T', 'TR-Discretionary'],
      ],
      report_date_options: [
        ['APPL', 'お申込書類受領日'],
        ['APPLSENT', 'お申込書類発送日'],
        ['POLICY', '実行日'],
      ],
      client_date_options: [['APPL', 'お申込書類受領日'], ['POLICY', '実行日']],
      report_type_options: {
        'afs': [
          [1, '1. 契約失効 / 解約済レポート'],
          [2, '2. 新規お客様レポート'],
          [3, '3. 新規ビジネスレポート'],
          [4, '4. セールスパフォーマンスレポート'],
          [5, '5. トランスファーインレポート'],
          [6, '6. お客様お誕生日レポート'],
          [7, '7. 積立金滞納レポート'],
          [8, '8. クレジットカード有効期限レポート'],
          [9, '9. お客様ポートフォリオレポート'],
          [10, '10. 既存ビジネスレポート'],
          [11, '11. プラン詳細レポート'],
          [12, '12. 既存お客様レポート'],
          [13, '13. プラン合計支払額レポート'],
          [14, '14. お客様合計支払額レポート'],
          // [201, '201. Training History Report'],  // FIXME: per user request hide this report
        ],
        'ipc': [
          [1, '1. 既存ビジネスレポート'],
          [2, '2. プラン詳細レポート'],
          [3, '3. 既存お客様レポート'],
          [4, '4. セールスパフォーマンスレポート'],
          [5, '5. お客様お誕生日レポート'],
        ],
        'absg': [
          [1, '1. 既存ビジネスレポート'],
          [2, '2. プラン詳細レポート'],
        ]
      },
      product_type_options: [
        ['', ' - 全て - '],
        ['IL', 'ユニットリンク型'],
        ['IN', '保険プラン'],
      ],
      exclude_status_options: [
        ['CAN', 'ﾌﾟﾗﾝ解約'],
        ['COF', 'クーリングオフ期間終了'],
        ['LAP', '契約失効'],
        ['SUR', '解約済'],
        ['TOT', 'トランスファーアウト'],
      ],
      lapsed_surrender_options: [
        ['', ' - 全て - '],
        ['LAP', '契約失効'],
        ['SUR', '解約済'],
      ],
      status_options: [['All', ' - 全て - '], ['O', '手続中'], ['C', '手続完了']],
      policy_status: [
        ['RCV', 'お申込書類受領'],
        ['AIP', 'ﾌﾟﾗﾝ手続中'],
        ['ACT', '受付完了'],
        ['CAN', 'ﾌﾟﾗﾝ解約'],
        ['INF', 'ﾌﾟﾗﾝ継続中'],
        ['COF', 'クーリングオフ期間終了'],
        ['MAT', '満期'],
        ['LAP', '契約失効'],
        ['SUR', '解約済'],
        ['TOT', 'トランスファーアウト'],
        ['OPN', 'プラン開始'],
        ['CFM', ''],
        ['TER', 'プラン終了'],
        ['COD', '解約済'],
      ],
      exclude_policy_status: [
        ['COD', 'アカウントクローズ'],
        ['CAN', 'プランキャンセル'],
        ['COF', 'クーリングオフ期間終了'],
        ['LAP', '契約失効'],
        ['SUR', '解約済'],
        ['TOT', 'トランスファーアウト'],
        ['TER', 'プラン終了'],
      ],
      product_type: [
        ['IL', 'ユニットリンク型'],
        ['IN', '保険プラン'],
        ['FD', 'ファンドプラットフォーム'],
        ['GI', '損害保険'],
        ['MPF', 'MPF'],
        ['PB', 'プライベートバンク'],
        ['TU', '信託プラン'],
      ],
      b2b_product_type: [
        ['IL', 'ユニットリンク型'],
        ['IN', '保険プラン'],
        ['FD', 'ファンドプラットフォーム'],
        ['GI', '損害保険'],
        ['MPF', 'MPF'],
        ['PB', 'プライベートバンク'],
        ['TU', '信託プラン'],
      ],
    },
    login: {
      select_area: '選択ください :',
      select_client: 'お客様ログイン',
      select_producer: 'パートナーログイン',
      login_btn: 'ログイン',
      login: 'お客様ログインID（AGから始まる8桁の数字）',
      login_b2b: 'ログイン ID',
      password: 'パスワード',
      loginHelpB2c: 'お申込時にアテナベストよりお送りした「契約証書の送付状」／「ウェブサイト案内メール」、または過去にお送りした「運用状況報告書」上に記載（例：AG12345678）',
      passwordHelpB2c: 'アルファベット・数字より6-10字以内でご入力下さい',
      loginWording: 'ログインすることにより、',
      disclaimer: '免責条項',
      and: ' 及び ',
      privacyPolicy: 'プライバシーポリシー',
      loginWording2: 'に同意したものとみなされます。',
      newUser: '初めてご利用の方は',
      activateYourAccount: 'ユーザー設定',
      newUser2: 'を行ってください。',
      cannotLogin: 'パスワードをお忘れの方は、',
      cannotLogin_b2b: 'パスワードをお忘れの方は、',
      forgetLoginIdPassword: 'こちら',
      cannotLogin2: 'よりお進みください。',
      forgetPassword: 'こちら',
      needHelp: '',
      needHelpPlease: '',
      faq_1: '',
      faq_2: '',
      faq_3: '',
      needAssistant: '',
      contactUs: '',
      inquiry_1: 'サポートが必要な場合には、こちら(',
      inquiry_2: ')よりお問い合わせください。',
    },
    activation: {
      online_reg_title: 'オンライン登録',
      login_id: 'お客様ログインID',
      identification_number: 'お客様ログインID',
      identification_number_placeholder: 'AGから始まる8桁の数字（AGXXXXXXXX）',
      identification_number_tooptip_text: 'お申込時にアテナベストよりお送りした「契約証書の送付状」／「ウェブサイト案内メール」、または過去にお送りした「運用状況報告書」上に記載（例：AG12345678）',
      date_of_birth: '生年月日',
      code: '認証コード',
      new_password: 'パスワード（6～10文字以内/半角英数字）',
      password_confirmation: '確認のため、もう一度パスワードを入力ください',
      submit: '送信ボタン',
      reg_sub_title: 'アカウント申請',
      reg_form_head_title: 'お客様情報を入力ください（半角英数字）',
      dd: '日日',
      mm: '月月',
      yyyy: '年年年年',

      with_email: {
        sub_title: 'リンクが送信されました！',
        content_line1: 'アカウント有効化のためのリンクがお客様のご登録メールアドレス "{{email}}" ',
        content_line2: 'へと送信されました。メール本文記載の手順に従って登録を進めてください。',
        content_line3: 'もし30分経過してもメールを受信されない場合には、以下の「再送」ボタンをクリックください。',
        content_line4: 'メールが再送されます。',
      },
      without_email: {
        sub_title: 'E-MAILアドレスのご登録が見当たりません。',
        content_line1: 'E-MAILアドレスをご登録ください。アテナベスト',
        content_line2: 'またはお客様のサポート会社へとお問い合わせください。',
        content_form_name: '',
        content_line3: '',
        content_line4: '',
        content_line5: '',
      },

      activate_sub_title: 'パスワードを設定ください',
      activate_success_sub_title: '登録が完了しました！',
      activate_success_content_line1: '今後ログインの際には、',
      activate_success_content_line2: ' {{loginId}} をお客様ログインIDとしてご利用ください',
      go_to_login: 'ログインページへ移動',
      send_again: '再送',
    },
    forget_password: {
      login_id: 'お客様ログインID',
      login_id_b2b: 'ログインID',
      identification_number: 'お客様ログインID',
      identification_number_placeholder: 'AGから始まる8桁の数字（AGXXXXXXXX）',
      identification_number_tooptip_text: 'お申込時にアテナベストよりお送りした「契約証書の送付状」／「ウェブサイト案内メール」、または過去にお送りした「運用状況報告書」上に記載（例：AG12345678）',
      date_of_birth: '生年月日',
      code: '認証コード',
      submit: '送信ボタン',
      title: 'パスワードをお忘れの方',
      title_b2b: 'パスワードをお忘れの方',
      sub_title: '本人確認',
      form_head_title: 'お客様情報を入力ください（半角英数字）',
      form_head_title_b2b: '下記情報を入力ください（半角英数字）',
      go_to_login: 'ログインページへ移動',
      send_again: '再送',
      dd: '日日',
      mm: '月月',
      yyyy: '年年年年',

      with_email: {
        sub_title: 'リンクが送信されました！',
        content_line1: 'アカウント有効化のためのリンクがお客様のご登録メールアドレス "{{email}}" ',
        content_line2: 'へと送信されました。メール本文記載の手順に従って登録を進めてください。',
        content_line3: 'もし30分経過してもメールを受信されない場合には、以下の「再送」ボタンをクリックください。',
        content_line4: 'メールが再送されます。',
      },
      without_email: {
        sub_title: 'E-MAILアドレスのご登録が見当たりません。',
        content_line1: 'E-MAILアドレスをご登録ください。アテナベスト',
        content_line2: 'またはお客様のサポート会社へとお問い合わせください。',
        content_form_name: '',
        content_line3: '',
        content_line4: '',
        content_line5: '',
      },
      reset_password: {
        title: 'パスワードをお忘れの方',
        title_b2b: 'パスワードをお忘れの方',
        sub_title: 'パスワードの再設定が必要です',
        login_id: 'お客様ログインID',
        login_id_b2b: 'ログインID',
        new_password: 'パスワード（6～10文字以内/半角英数字）',
        password_confirmation: '確認のため、もう一度パスワードを入力ください',
        code: '認証コード',
      },
      reset_success: {
        sub_title: '手続が完了しました！',
        content_line1: 'パスワードが再設定されました。',
        content_line2: 'ログインの際には、{{loginId}}をお客様ログインIDとしてご利用ください。',
      },
    },
    change_password: {
      label: 'パスワード変更',
      description: 'パスワードは半角英数字6～10文字以内にて設定ください',
      current: '既存パスワード',
      new: '新しいパスワード',
      confirm_new: '新しいパスワード再入力',
      success_message: 'パスワードが設定されました。',
    },
    statement: {
      total_portfolio_value_alert:
        '商品プロバイダーからのデータ提供にて不具合が生じた為、運用報告書が表示できておりません。 ご迷惑をおかけして申し訳ございませんが、問題が解決するまで暫くお時間頂戴できます様お願い致します。',
    },
    report: {
      reports: 'レポート',
      product_type: '商品タイプ',
      exclude: '検索対象より除外',
      month: '月',
      type: 'タイプ',
      to: 'to',
      lapsed_surrender_date: '契約失効 / 解約済日 (YYYY/MM/DD)',
      transfer_in_effective_date: 'トランスファーイン有効日 (YYYY/MM/DD)',
      sr_created_date: 'サービス記録作成日 (YYYY/MM/DD)',
      cc_expiry_date: 'クレジットカード有効期限 (YYYY/MM)',
      received_date: '受領日 (YYYY/MM/DD)',
      date_attened: 'Date Attened (YYYY/MM/DD)',
      export: 'エクセル表示',
    },
  },
};

export default commonJa;
